import { useId } from "react";
import { LOCALES, isLocale } from "@/i18n/registry";
import { useT } from "@/i18n/useT";

export function LanguageSwitch() {
  const { t, locale, setLocale } = useT();
  const selectId = useId();
  return (
    <div className="flex items-center gap-2 text-[13px]">
      <label htmlFor={selectId} className="text-[var(--muted)]">
        {t("common.language")}
      </label>
      <select
        id={selectId}
        value={locale}
        onChange={(event) => {
          const next = event.target.value;
          if (isLocale(next)) setLocale(next);
        }}
        className="min-h-[28px] rounded-[6px] border border-[var(--border)] bg-[var(--surface)] px-2 text-[var(--fg)]"
      >
        {LOCALES.map((code) => (
          <option key={code} value={code}>
            {t(`common.language.${code}`)}
          </option>
        ))}
      </select>
    </div>
  );
}
